import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-faeac046"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_upload_pdf",
  ref: "UploadPDFRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_sale_order_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-10" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-7" }
const _hoisted_12 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-7" }
const _hoisted_15 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "form-group mb-7" }
const _hoisted_18 = { class: "svg-icon svg-icon-3tx svg-icon-primary pe-4" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_21 = { class: "text-gray-400 fw-semibold fs-6" }
const _hoisted_22 = { class: "file-item" }
const _hoisted_23 = { class: "me-12" }
const _hoisted_24 = { class: "file-name text-dark fw-semibold" }
const _hoisted_25 = { class: "d-flex gap-2" }
const _hoisted_26 = { class: "file-size text-gray-400 fw-semibold" }
const _hoisted_27 = {
  key: 0,
  class: "upload-status-tips text-success fw-semibold"
}
const _hoisted_28 = { class: "svg-icon svg-icon-3 svg-icon-success" }
const _hoisted_29 = {
  key: 1,
  class: "upload-status-tips text-danger fw-semibold"
}
const _hoisted_30 = { class: "svg-icon svg-icon-3 svg-icon-danger" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "svg-icon svg-icon-1 me-0" }
const _hoisted_33 = { class: "modal-footer flex-end" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "indicator-label" }
const _hoisted_38 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_39 = { class: "indicator-progress" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("shipmentLabel.uploadShipmentLabel")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("shipmentLabel.channel2")), 1),
                    _createVNode(_component_el_form_item, { prop: "channel" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.channel,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.channel) = $event)),
                          filterable: "",
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Logiline",
                              value: "Logiline"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("shipmentLabel.logisticsServiceProvider")), 1),
                    _createVNode(_component_el_form_item, { prop: "service_provider" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.service_provider,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.service_provider) = $event)),
                          filterable: "",
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.service_provider, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_el_form_item, { prop: "file_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_upload, {
                          action: "",
                          ref: "uploadRef",
                          class: _normalizeClass(["multiple-drag-upload", { hasfile: _ctx.fileList.length > 0 }]),
                          drag: "",
                          multiple: "",
                          limit: _ctx.maxFiles,
                          "file-list": (_ctx.fileList as any),
                          "auto-upload": false,
                          "show-file-list": true,
                          accept: ".pdf",
                          headers: (_ctx.uploadHeaders as any),
                          "on-change": _ctx.onUploadChange
                        }, {
                          file: _withCtx(({ file }) => [
                            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, _toDisplayString(file.name), 1),
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, _toDisplayString((file.size / 1024).toFixed(2)) + "kb ", 1),
                                  (file.status == 'success')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("span", _hoisted_28, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                                        ]),
                                        _createTextVNode(" " + _toDisplayString(_ctx.t("shipmentLabel.uploadSuccessful")), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (file.status == 'fail')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createElementVNode("span", _hoisted_30, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                        ]),
                                        _createTextVNode(" " + _toDisplayString(_ctx.t("shipmentLabel.uploadFailed")), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-icon btn-light-danger flex-none",
                                onClick: ($event: any) => (_ctx.handleRemove(file))
                              }, [
                                _createElementVNode("span", _hoisted_32, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                                ])
                              ], 8, _hoisted_31)
                            ])), [
                              [_directive_loading, file.status == 'ready']
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_18, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil010.svg" })
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("shipmentLabel.dragFilesHereOrClickHereToUpload")), 1),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t("shipmentLabel.uploadUpToFiles", [_ctx.maxFiles])), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["class", "limit", "file-list", "headers", "on-change"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-light me-3",
                disabled: _ctx.loading || _ctx.uploadLoading,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_35, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ], 8, _hoisted_34),
              _createVNode(_component_permission_common, { role: { auth: ['add'] } }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    ref: "submitButton",
                    type: "button",
                    class: "btn btn-lg btn-primary",
                    disabled: _ctx.loading || _ctx.uploadLoading,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                    ]),
                    _createElementVNode("span", _hoisted_39, [
                      _hoisted_40,
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                    ])
                  ], 8, _hoisted_36)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}